<template>
  <section class="upcoming-section">
    <div class="container">
      <div class="nav-wrapper">
        <h1 class="title">{{ upcomingPageTitle }}</h1>

        <div class="nav-buttons">
          <div class="dots">
            <div
              v-for="(event, index) in upcomingEvents"
              :key="index"
              class="dot"
              :class="dataItems.index === index && 'active'"
            ></div>
          </div>
          <div
            v-if="hasLibraryEvents"
            class="chevrons"
          >
            <button
              class="chevron-left"
              :class="dataItems.index === 0 && 'disabled'"
              aria-label="prev"
              @click="setActiveItem('prev')"
            >
              <ChevronLeftIcon :stroke-width="3" />
            </button>
            <button
              class="chevron-right"
              :class="
                dataItems.index === upcomingEvents.length - 2 && 'disabled'
              "
              aria-label="next"
              @click="setActiveItem('next')"
            >
              <ChevronRightIcon />
            </button>
          </div>
        </div>
      </div>

      <div class="events-container">
        <div
          ref="carousel"
          class="events"
          :style="`left:${dataItems.left}`"
          :class="{ hidden: !hasLibraryEvents }"
        >
          <EventCard
            v-for="event in upcomingEvents"
            ref="eventRef"
            :key="event.id"
            :event="event"
            class="event"
            vertical-layout
          />
        </div>
        <div
          v-if="!hasLibraryEvents"
          class="events-card-container"
        >
          <EventCard
            v-for="event in upcomingEvents"
            :key="event.id"
            :event="event"
            class="event"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import EventCard from '../EventCard/EventCard.vue';
import ChevronLeftIcon from '~/components/Common/Svg/ChevronLeftIcon.vue';
import ChevronRightIcon from '~/components/Common/Svg/ChevronRightIcon.vue';
import carousel from '~/mixins/carousel';

export default {
  components: {
    EventCard,
    ChevronRightIcon,
    ChevronLeftIcon,
  },
  mixins: [carousel],
  props: {
    upcomingEvents: {
      type: Array,
      default: () => [],
    },
    hasLibraryEvents: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    date() {
      return this.$route.query.date;
    },
    upcomingPageTitle() {
      return !this.hasLibraryEvents && this.date !== undefined
        ? `Events in ${this.date}`
        : 'Upcoming events';
    },
  },
  methods: {
    setActiveItem(direction, isMobile = false) {
      const currentIndex = this.dataItems.index;
      const eventWidth = this.$refs.eventRef[0].$el.clientWidth ?? 0;
      const lastIndex = this.upcomingEvents.length - (isMobile ? 1 : 2);
      const newIndex =
        direction === 'next' ? currentIndex + 1 : currentIndex - 1;
      const increment = direction === 'next' ? -1 : 1;

      if (newIndex < 0 || newIndex > lastIndex) {
        return;
      }
      this.dataItems = {
        left: `${this.dataItems.value + increment * eventWidth}px`,
        value: this.dataItems.value + increment * eventWidth,
        index: newIndex,
        transition: '0.6s',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import './UpcomingSection.scss';
</style>
